import React from "react";
import FieldErrorMsg from "./FieldErrorMsg";
import notify from "./notify";
import { MdOutlineTipsAndUpdates } from "react-icons/md";
import Popover from "./Popover";
import { projectTipsData } from "../../data/projects";
import useTokenPrices from "../../hooks/useTokenPrices";
const TextField = ({
  containerClass = "w-40  ",
  inputClass = "h-12",
  id,
  onChange,
  value,
  title,
  placeholder,
  disabled = false,
  formik,
  onBlur = () => {},
  description = "",
  type = "text",
  icons,
  currentIcon,
  tipsId,
  autoFocus = false,
  required = false,
  shouldShowDollarAmount = false,
}) => {
  const error = () => {
    if (formik && formik.touched?.[id] && formik.errors?.[id]) return true;
    else return false;
  };
  const { toDollar } = useTokenPrices();

  return (
    <div
      onClick={() =>
        disabled &&
        notify(`You cannot change the ${title} after the project is published.`)
      }
      className={`${containerClass} flex flex-col font-roboto relative ${
        disabled && "opacity-70"
      }`}
    >
      {title ? (
        <label htmlFor={id} className={" pl-2 h-7"}>
          <div className="flex items-center mb-1">
            <h3 className="font-bold text-sm">{title}</h3>
            {required && <span className="text-red-500 ml-1">*</span>}
            {projectTipsData?.[tipsId ?? id] && (
              <Popover
                detailElement={projectTipsData?.[tipsId ?? id]}
                title={title}
                index={0}
              >
                <MdOutlineTipsAndUpdates className="text-primary ml-1 -mt-3 text-lg mlg:text-xl" />
              </Popover>
            )}

            {shouldShowDollarAmount && (
              <span className="text-custom-gray-700">
                ($
                {toDollar({
                  amount: value,
                  token: currentIcon,
                })}
                )
              </span>
            )}
          </div>

          {description && <p className="text-xs mb-1">{description}</p>}
        </label>
      ) : null}
      <span className="h-[calc(100%+28px)] absolute right-3 top-0 flex items-center pointer-events-none">
        {icons && (
          <img
            src={icons[currentIcon]}
            alt={currentIcon}
            className="w-6 mr-1"
          />
        )}
        <span className="text-sm font-bold">{currentIcon}</span>
      </span>

      <input
        type={type}
        placeholder={placeholder}
        {...(type === "number" && { step: "any" })}
        onChange={(e) => {
          onChange?.(e);
          formik && formik.handleChange(e);
          // formik?.setFieldTouched(id, false);
        }}
        value={value}
        disabled={disabled}
        onWheel={(e) => type === "number" && e.target.blur()}
        className={`w-full rounded-[10px] text-sm font-[poppins] ${
          icons ? "pr-20" : "pr-6"
        } pl-3  focus:border-primary   custom-select-box focus:border-2 bg-transparent custom-select-box  ${
          error()
            ? " border-2 border-red-500"
            : " border border-custom-gray-600"
        }  ${inputClass} ${disabled && "pointer-events-none"} `}
        id={id}
        autoFocus={autoFocus}
      />

      <FieldErrorMsg formik={formik} id={id} />
    </div>
  );
};

export default TextField;
